import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-read',
  templateUrl: './read.component.html',
  styleUrls: ['./read.component.less']
})
export class ReadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

  checkNFC()


  
  {



   //nfc.on('reader', reader => {
 
//    console.log(`${reader.reader.name}  device attached`);
 
    // enable when you want to auto-process ISO 14443-4 tags (standard=TAG_ISO_14443_4)
    // when an ISO 14443-4 is detected, SELECT FILE command with the AID is issued
    // the response is available as card.data in the card event
    // see examples/basic.js line 17 for more info
    // reader.aid = 'F222222222';
  // });

  }

}
